import { cn } from '@commenda/utils';
import { ServiceRequestModel } from '@commenda/utils/models/service-request';
import { TaskStatus } from '@prisma/client';
import moment from 'moment';
import { ServiceRequestTaskLabelConfig } from '../taskIconConfig';

type ServiceRequestTaskLabelProps = {
  icon?: React.ReactNode; // Todo @devin: delete this and see where it breaks after the  migration to new services UI
  label: string;
  className?: string;
  children?: React.ReactNode;
  timestamp?: Date;
  status?: TaskStatus;
};

export const ServiceRequestTaskLabel = ({
  icon,
  label,
  className = '',
  children,
  timestamp,
  status,
}: ServiceRequestTaskLabelProps) => {
  return (
    <div className={cn(className)}>
      <span className={cn('block leading-relaxed', ServiceRequestModel.getTaskLabelTextColor(status))}>
        {label}
      </span>
      {icon}
      {timestamp && (
        <span className="flex text-xs text-text-tertiary mt-1">
          {ServiceRequestTaskLabelConfig[status]}
          {moment(new Date(timestamp)).format('ll [at] LT')}
        </span>
      )}
      {children}
    </div>
  );
};
